import { isMac } from '@wix/editor-elements-common-utils';
import { useEffect, useState } from 'react';
import type { TranslationKeys } from '../constants';

export function useActionTranslations(translations: {
  [key in keyof typeof TranslationKeys]: string;
}) {
  const [isMacOs, setIsMacOs] = useState(false);

  useEffect(() => {
    setIsMacOs(isMac());
  }, []);

  return {
    ...(isMacOs
      ? {
          toolbarBoldAction: translations.toolbarBoldMac,
          toolbarItalicAction: translations.toolbarItalicMac,
          toolbarUnderlineAction: translations.toolbarUnderlineMac,
          toolbarNormalTextAction: translations.toolbarNormalTextMac,
          toolbarTitleAction: translations.toolbarTitleMac,
          toolbarSubtitleAction: translations.toolbarSubtitleMac,
          toolbarBulletedListAction: translations.toolbarBulletedListMac,
          toolbarNumberedListAction: translations.toolbarNumberedListMac,
          toolbarAlignLeftAction: translations.toolbarAlignLeftMac,
          toolbarAlignCenterAction: translations.toolbarAlignCenterMac,
          toolbarAlignRightAction: translations.toolbarAlignRightMac,
          toolbarAlignJustifyAction: translations.toolbarAlignJustifyMac,
          toolbarLinkAction: translations.toolbarLinkMac,
        }
      : {
          toolbarBoldAction: translations.toolbarBoldPc,
          toolbarItalicAction: translations.toolbarItalicPc,
          toolbarUnderlineAction: translations.toolbarUnderlinePc,
          toolbarNormalTextAction: translations.toolbarNormalTextPc,
          toolbarTitleAction: translations.toolbarTitlePc,
          toolbarSubtitleAction: translations.toolbarSubtitlePc,
          toolbarBulletedListAction: translations.toolbarBulletedListPc,
          toolbarNumberedListAction: translations.toolbarNumberedListPc,
          toolbarAlignLeftAction: translations.toolbarAlignLeftPc,
          toolbarAlignCenterAction: translations.toolbarAlignCenterPc,
          toolbarAlignRightAction: translations.toolbarAlignRightPc,
          toolbarAlignJustifyAction: translations.toolbarAlignJustifyPc,
          toolbarLinkAction: translations.toolbarLinkPc,
        }),
  };
}
